









































































































































































import { Component, Prop } from 'vue-property-decorator';
import { Student } from '../../../src_server/entity/generated/Student';
import { InputPages } from '../../components/organisms/InputPages';
import historykana from 'historykana';
import { shintaiShougaisyaGradeOptions } from '../../../src_server/entity/master/shintaiShougaisyaGradeOptions';
import { hearingAidDataOptions, hearingAidAboutDataOptions } from '../../../src_server/entity/master/heaingAidData';
import ErrorSummary from '../../components/inputs/ErrorSummary.vue';
import { Session } from '../../utils/Session';
// import SimpleSelect from '../../components/inputs/SimpleSelect.vue';

@Component({
  components: { ErrorSummary },
})
export default class StudentInfoPage extends InputPages {
  @Prop()
  value!: Student;
  get model(): Student {
    return this.value;
  }

  set model(value: Student) {
    this.value = value;
  }

  get yesNoOption() {
    return [
      { title: 'いいえ', value: 0 },
      { title: 'はい', value: 1 },
    ];
  }
  get shintaiShougaisyaGrade() {
    return shintaiShougaisyaGradeOptions;
  }

  get hearingAidAboutData() {
    return hearingAidAboutDataOptions;
  }
  get hearingAidData() {
    return hearingAidDataOptions;
  }
  get isCO() {
    return Session.isCircleOBuilding();
  }
  private keyHistory: string[] = [];
  // inputName(e: Event) {
  //   const key = (e.target as HTMLInputElement).value;
  //   if (key === '') {
  //     this.keyHistory = [];
  //   }
  //   this.keyHistory.push(key);
  //   this.model.full_name_kana = historykana(this.keyHistory);
  // }
}
